/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
// remember to grab v7 when it's released
import ReactTable  from 'react-table';
import { Grid, Row, Col } from 'react-flexbox-grid';
import './react-table.css'
import './SteamPlayed.css';

const proxyUrl = "https://cors-anywhere.herokuapp.com/"
const signOnUrl = "https://yy4hykl3ti.execute-api.us-east-1.amazonaws.com/prod/auth/steam";
// const signOnUrl = "http://localhost:3001/auth/steam";

function SteamPlayed(props) {
  const [data, setData] = useState(null);
  const [userId, setUserId] = useState(null);

  const getUserProfileUrl = `http://api.steampowered.com/IPlayerService/GetOwnedGames/v0001/?key=7813876CA4146DF8758A701FAF9C9A99&steamid=${userId}&include_appinfo=1&nclude_played_free_games=1&format=json`;

  const columns = [{
    accessor: 'games',
    columns: [{
      Header: 'Game Name',
      accessor: 'name'
    },{
      Header: 'Played Time (mins)',
      accessor: 'playtime_forever'
    }],
  }]

  const defaultSorted = [
    {
      id: "playtime_forever",
      desc: true
    }
  ]

  useEffect(() => {
    setUserId(window.userid)
  }, []);

  useEffect(() => {
    console.log('loaded... userId:', userId)
    if (userId) {
      fetch(proxyUrl + getUserProfileUrl)
      .then(response => {
        if (!response.ok) {
          this.handeResponseError(response);
        }
        return response.json();
      })
      .then(result => {
        console.log(result);
        console.log(data);
        setData(result.response.games);
      });
    }
  }, [userId]);


  const handleLoginClick = () => {
    window.location.assign(signOnUrl);
  }

  const handleLogoutClick = () => {
    setUserId(null);
    setData(null);
  }

  return (
      <>   
        <Grid fluid>
          <Row center='xs'> 
            <Col xs={9}>
              <Row start='xs'>
                <h1>Steam Played Time </h1>
              </Row>
              <Row>
                <p>This third-party tool allows Steam users to view the total played times of their Steam libray.</p>
                <p>(It was also an excuse to learn more React, Node Express, and various tools within the AWS stack.)</p>
              </Row>
            </Col>
            <Col xs={3}>
              <Row end='xs'>
                {
                  !userId ? 
                    <button className='btn_green_white_innerfade' onClick={handleLoginClick}>Log In To Steam</button> :
                    <button className='btn_green_white_innerfade' onClick={handleLogoutClick}>Log Out</button>
                }
              </Row>
            </Col>
          </Row>
        </Grid> 
        { 
            data &&
            <ReactTable 
              data={data} 
              columns={columns}
              defaultSorted={defaultSorted}
              defaultPageSize={data.length}
            />
        }
      </>
  );
}

export default SteamPlayed;
